import * as Icons from 'lucide-react';
import { HUMAN_CONTROL } from '../../config/site';
import { SectionHeader } from '../common';

export default function AIHumanControl() {
  return (
    <section className="section" style={{ background: 'var(--bg-2)', borderTop: '1px solid var(--border)', borderBottom: '1px solid var(--border)' }}>
      <div className="container-x">
        <div className="reveal"><SectionHeader center eyebrow="AI + Human Control" title="AI finds the opportunity. You stay in control." sub="Kalki AI is decision support, not a hands-off promise. Intelligence surfaces the setup — you decide, then execute with defined risk." /></div>
        <div className="grid md:grid-cols-3 gap-5 mt-14">
          {HUMAN_CONTROL.map((c, i) => {
            const Icon = Icons[c.icon] || Icons.Circle;
            return (
              <div key={c.title} className="panel panel-hover p-8 reveal text-center" style={{ transitionDelay: `${i * 80}ms` }}>
                <div className="w-14 h-14 rounded-2xl flex items-center justify-center mx-auto mb-5" style={{ background: 'var(--gold-soft)', border: '1px solid var(--gold-border)' }}><Icon size={24} className="text-[var(--gold-2)]" /></div>
                <div className="font-mono text-[11px] text-[var(--muted-2)] mb-1">0{i + 1}</div>
                <h3 className="font-display text-[19px] font-bold text-white">{c.title}</h3>
                <p className="text-[14px] text-[var(--muted)] mt-2.5 leading-relaxed">{c.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
